const rankingData = [
  { rank: 1, title: '流浪地球3', hot: '985万热度', genre: '科幻', tag: 'NEW' },
  { rank: 2, title: '哪吒之魔童闹海', hot: '872万热度', genre: '动画', tag: 'HOT' },
  { rank: 3, title: '封神第二部', hot: '756万热度', genre: '奇幻', tag: '热播' },
  { rank: 4, title: '热辣滚烫', hot: '691万热度', genre: '喜剧', tag: '' },
  { rank: 5, title: '第二十条', hot: '623万热度', genre: '剧情', tag: '' },
  { rank: 6, title: '飞驰人生2', hot: '588万热度', genre: '喜剧', tag: '' },
  { rank: 7, title: '周处除三害', hot: '531万热度', genre: '动作', tag: '新片' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门榜单</h2>
          <p className="text-sm text-foreground-500 max-w-[560px] mx-auto">实时热度排行，聚合全网观众观影选择，助你发现当下最受欢迎的影视佳作。</p>
        </div>

        <div className="space-y-2.5">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/40 transition-all cursor-pointer group"
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-heading font-bold text-sm shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">{item.title}</h3>
                  {item.tag && (
                    <span className={`whitespace-nowrap px-1.5 py-0.5 rounded text-[10px] font-medium ${
                      item.tag === 'NEW' ? 'bg-accent-100 text-accent-700' :
                      item.tag === 'HOT' ? 'bg-primary-100 text-primary-600' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>{item.tag}</span>
                  )}
                </div>
                <span className="text-xs text-foreground-400">{item.genre}</span>
              </div>
              <div className="text-sm font-medium text-primary-500 whitespace-nowrap shrink-0">{item.hot}</div>
              <div className="w-7 h-7 flex items-center justify-center shrink-0 text-foreground-300 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-play-circle-line text-lg"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}